module.exports = __webpack_public_path__ + "img/num4.4b6f8642.png";